<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  header="Addresses"
  (onHide)="onHide()">
  <div class="vendorDetails-section mb-4">
    <div class="scroll-box-hgt-drawer">
      <li
        class="d-flex p-3 add-col"
        *ngFor="let item of vendorAddressInformation; let i = index">
        <div class="icon">
          <i class="pi pi-map-marker"></i>
        </div>
        <div class="ms-2 w-100">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '1'">Vendor</h3>
            <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '2'">Inside</h3>
            <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '5'">Website</h3>
            <span
              class="badge bg-primary me-auto"
              *ngIf="item.isPrimaryD365 === 'YES'"
              >Primary</span
            >
            <span class="tag ml-auto" *ngIf="i === 0">Business</span>
            <span class="tag ml-auto" *ngIf="i === 1">Business Delivery</span>
            <span class="tag ml-auto" *ngIf="i === 2">Delivery</span>
          </div>
          <div class="d-flex">
            <i class="icon-address me-1"></i>
            <address class="mb-0 address" (click)="openEditAddress(item)">
              {{
                item.streetD365 +
                  " " +
                  item.streetNumberD365 +
                  " " +
                  item.cityD365 +
                  ", " +
                  item.stateD365 +
                  ", " +
                  item.zipCodeD365
              }}
            </address>
          </div>
        </div>
      </li>
    </div>
  </div>
</p-drawer>
